/**
 * Dashboard landing. Placeholder stat cards for now — the real submission /
 * review / analytics surfaces mount as their routes land. Token-themed via the
 * shared .card classes.
 */

import { FileText, Clock, CheckCircle, TrendingUp } from 'lucide-react';

const STATS = [
  { label: 'Total Records', value: '0', icon: FileText },
  { label: 'Pending Review', value: '0', icon: Clock },
  { label: 'Approved', value: '0', icon: CheckCircle },
  { label: 'This Month', value: '0', icon: TrendingUp },
];

export function DashboardPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
          Dashboard
        </h1>
        <p style={{ color: 'var(--text-tertiary)', margin: '0.25rem 0 0' }}>
          Decision and documentation records.
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
        }}
      >
        {STATS.map(({ label, value, icon: Icon }) => (
          <div className="card" key={label}>
            <div className="card-header">
              <span className="card-title">{label}</span>
              <Icon size={20} style={{ color: 'var(--brand-primary)' }} />
            </div>
            <div className="card-value">{value}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <h3 style={{ fontSize: '1rem', fontWeight: 600, marginTop: 0, color: 'var(--text-primary)' }}>
          Recent activity
        </h3>
        <p style={{ color: 'var(--text-tertiary)', margin: 0 }}>
          No records yet. Start by submitting a decision record.
        </p>
      </div>
    </div>
  );
}
